export const TRIP_TOTAL_TEXT = "Trip total";